import { render } from "./initialMessage.vue?vue&type=template&id=29c1accc"
import script from "./initialMessage.vue?vue&type=script&lang=js"
export * from "./initialMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__